<template>
	<section>

		<h3>
			Mes commandes
		</h3>


		<div class="row">
			<div class="col-md-12">

				<div v-for="(parcel, indexParcel) in parcels" :key="indexParcel">
					<div class="d-flex flex-row w-100 mb-2"> 
						<h4 class="flex-grow-1 mb-0">
							Commande du {{$moment(parcel.createdAt).format("DD/MM/YYYY [à] HH:mm")}}
						</h4>
					</div>
					<div class="alert alert-light">

						<h6 class="fw-bold">Statut</h6>
						
						Le {{$moment(parcel.pa_date).format("DD/MM/YYYY [à] HH:mm")}} : {{ getOrderStatus(parcel.pa_state) }}

						<div v-if="parcel.pa_state === 'SENT'">
							Mode de livraison : {{ getDeliveryCompany(parcel.pa_company) }}<br />
							N° de suivi : {{ parcel.pa_trackingcode }}
						</div>

						<h6 class="fw-bold mt-4">Adresse de livraison</h6>

						<span v-show="parcel.pa_shipping_civility">
							{{getCivility(parcel.pa_shipping_civility)}}&nbsp;
						</span>
						{{parcel.pa_shipping_firstname}} {{parcel.pa_shipping_name}}<br />

						<div class="mt-2">
							<div v-show="parcel.pa_shipping_society_name">
								{{parcel.pa_shipping_society_name}}
							</div>
							{{parcel.pa_shipping_address1}} <br />
							<span v-show="parcel.pa_shipping_address2">
								{{parcel.pa_shipping_address2}} <br/>
							</span>
							{{parcel.pa_shipping_zip}} {{parcel.pa_shipping_city}} <br />
							{{getCountry(parcel.pa_shipping_country)}}
						</div>

						<div class="mt-2">
							<label>téléphone : </label> {{parcel.pa_shipping_tel}}
						</div>

						<h6 class="fw-bold mt-4">Commentaire</h6>

						{{parcel.pa_comment}}

					</div>
				</div>
			</div>
		</div>		


	</section>
</template>

<script>

import FormContact from "./FormContact";

export default {
	name: "privateaccount",
	components: { FormContact },
	data() {
		return {
			row_co: {},
			endusers: [],
			parcels: []
		};
	},

	async mounted() {
		this.loadAccount();
	},
	computed: {

	},
	methods: {

		async loadAccount() {

			let response = await this.$axios.get(
				this.$config.server_url + "/web/2.0/account"
			);

			this.row_co = response.data.data.row_co;
			this.parcels = response.data.data.parcels;
			this.endusers = response.data.data.endusers;
		},

		getDeliveryCompany(val) {
			const res = this.$store.state.items_deliverycompany.find(item => item.value === val)
			return res ? res.text : "";
		},

		getCivility(val) {
			const res = this.$store.state.items_civility.find(item => item.value === val)
			return res ? res.text : "";
		},

		getCountry(val) {
			const res = this.$store.state.items_countries.find(item => item.value === val)
			return res ? res.text : "";
		},

		getOrderStatus(status) {

			const res = this.$store.state.items_pa_state.find(item => {
				return item.value === status;
			});

			if(res) {
				return `commande ${res.text}`;
			} else {
				return `échec de récupération du statut de la commande (${status})`;
			}
		}

}
};
</script>

<style lang="scss" scoped>
	.referral-code {
		display: inline-block;
		padding: 5px 10px;
		background-color: #F0F0F0;
		border: 1px solid #a0a0a0;
	}
</style>
